/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getPostThreadOtherV2.defs.js'
export { main as default } from './getPostThreadOtherV2.defs.js'
